import * as React from "react";
import { Icon, Popup } from "semantic-ui-react";
import { ActionStatus } from "../../stores/project/project";

export default function ActionStatusIcon({
                                             actionStatus,
                                             issues
                                         }: { actionStatus: ActionStatus, issues: string[] }): JSX.Element {
    if (actionStatus === "noActionRequired") {
        return <Popup wide="very"
                      content="Kein Handlungsbedarf"
                      trigger={
                          <Icon
                              circular={true}
                              color="green"
                              inverted={true}
                              size="small"/>}
        />
    }

    if (actionStatus === "actionRequired") {
        return <Popup wide="very"
                      content={issues.sort().map(i => <><span>{i}</span><br/></>)}
                      trigger={
                          <Icon
                              circular={true}
                              color="red"
                              inverted={true}
                              size="small"/>}
        />
    }
    return <Popup wide="very"
                  content="Projekt abgeschlossen"
                  trigger={
                      <Icon
                          circular={true}
                          color="green"
                          inverted={true}
                          size="small"
                          name="checkmark"/>}
    />
}
